import {Component, ElementRef, Inject, LOCALE_ID, Renderer2, ViewChild} from '@angular/core';
import {BaseComponent} from "../../../../base/components/base.component";
import {EventBusService} from "../../../../base/services/eventbus/event-bus.service";
import {ActivatedRoute, Router, UrlTree} from "@angular/router";
import {SubscriptionContainerService} from "../../../../base/services/subscription-container.service";
import {FormControl} from "@angular/forms";
import {LocalStorageService} from "../../../../base/services/storage/localstorage.service";
import {Utility} from "../../../common/modules/utility/utility";
import {FullScreenService} from "../../../dash/services/full-screen.service";
import {Locales, MenuTypeKey, MenuTypes} from "../../../../models/global.config";
import {IWebsiteDetail} from "../../../dash/domains/website/websites/models/website.model";
import {EventKey} from "../../../../registry/event.key";
import {HttpErrorResponse} from "@angular/common/http";
import {WebsiteService} from "../../../dash/domains/website/websites/services/website.service";
import {TextUtility} from "../../../common/modules/utility/text.utility";

@Component({
  selector: 'app-blog-header',
  templateUrl: './blog-header.component.html',
  styleUrls: ['./blog-header.component.scss']
})
export class BlogHeaderComponent extends BaseComponent {
  @ViewChild('rightBarToggle') rightBarToggle: ElementRef;

  protected readonly Locals = Locales;

  protected readonly Utility = Utility;

  protected readonly Locales = Locales;

  protected readonly MenuTypes = MenuTypes;

  blogSlug: string | null = null
  blogDetail: IWebsiteDetail | null = null

  search = new FormControl()

  currentLocale: Locales = Locales.EN
  menuType: MenuTypes = MenuTypes.HORIZONTAL

  protected componentName(): string {
    return BlogHeaderComponent.name;
  }

  constructor(
    eventBus: EventBusService,
    router: Router,
    subContainer: SubscriptionContainerService,
    private renderer: Renderer2,
    private activatedRoute: ActivatedRoute,
    @Inject(LOCALE_ID) protected locale: string,
    private fullScreenService: FullScreenService,
    private blogService: WebsiteService
  ) {
    super(eventBus, router, subContainer)

    this.fullScreenService.initFullScreen();

    LocalStorageService.retrieveAsync("locale", (lc) => {
      this.currentLocale = this.normalizeLocale(lc)
    })
  }

  ngOnInit(): void {

    this.blogSlug = TextUtility.extractSlug('blog', this.router.url)

    this.activatedRoute.queryParams.subscribe(params => {
      this.search.setValue(params['query'])
    })

    LocalStorageService.retrieveAsync("locale", (lc) => {
      this.currentLocale = this.normalizeLocale(lc)
    })

    this.fetchBlog(this.blogSlug!!, blog => {
      this.blogDetail = blog
    })

  }

  onSearch() {
    const urlTree: UrlTree = this.router.parseUrl(this.router.url);
    const path = urlTree.root.children['primary'].segments.map(segment => segment.path).join('/');

    this.router.navigate([path], {
      queryParams: {
        query: this.search.value,
      },
      queryParamsHandling: 'merge',
    }).then(r => {
    });
  }

  clearSearch() {
    this.search.setValue(null)
    this.onSearch()
  }

  initLeftMenuCollapse() {
    const body = document.body;

    body.classList.toggle('sidebar-enable');
    if (window.innerWidth >= 992) {
      body.classList.toggle('vertical-collpsed');
    } else {
      body.classList.remove('vertical-collpsed');
    }

    if (body.classList.contains('vertical-collpsed')) {
      this.renderer.addClass(body, 'vertical-collpsed');
    } else {
      this.renderer.removeClass(body, 'vertical-collpsed');
    }
  }

  setLocale(locale: Locales): void {
    LocalStorageService.put('locale', locale)

    this.currentLocale = locale;
    const currentUrl = this.router.url;
    let newUrl = currentUrl.replace(/\/[a-z]{2}(?:-[A-Z]{2})?\//, `/${locale}/`);
    if (!newUrl.startsWith('/' + locale + '/')) {
      newUrl = '/' + locale + '/#' + newUrl;
    }
    window.location.href = window.location.origin + newUrl;
  }

  onMenuTypeSelected(menuType: MenuTypes) {
    LocalStorageService.put(MenuTypeKey.BLOG, menuType)
    this.menuType = menuType;
    window.location.reload()
  }

  toggleFullScreen(event: Event): void {
    event.preventDefault();
    document.body.classList.toggle('fullscreen-enable');
    this.fullScreenService.toggleFullScreen();
  }

  fetchBlog(slug: string, then: (website: IWebsiteDetail) => void) {
    this.loading = true
    let key = this.componentKey(EventKey.BLOGS.GET_BY_SLUG(slug))
    this.blogService.fetchBySlug(key, slug)
    this.subscribe(key, null, (value, meta) => {
      this.loading = false;
      then(meta.data)
    })
    this.subscribe(this.getErrorKey(key), null, (value, meta) => {
      let error: HttpErrorResponse = meta.data
      console.log(error)
      this.loading = false;
    })
  }

  private normalizeLocale(locale: unknown): Locales {
    if (locale === 'en-US') return Locales.EN;
    if (locale === 'bn-BN') return Locales.BN_BN;
    return (locale as Locales) || Locales.EN;
  }

}
